import { Link } from '@tanstack/react-router';
import { PortfolioCompanyResponse } from '~/api/def/endpoints/portfolioCompanyEndpoint';

export function PortfolioLinkCell(props: {
  value: string;
  data: PortfolioCompanyResponse;
  fundId?: string;
  fundName?: string;
}) {
  if (!props.value) {
    return '-';
  }
  return (
    <Link
      color="info"
      className="underline-on-hover"
      to={`/portfolio-company/${props.data.id}${getPortfolioLinkParams({ fundId: props.fundId, fundName: props.fundName })}`}
    >
      {props.value}
    </Link>
  );
}

export const getPortfolioLinkParams = (params: {
  fundId?: string;
  fundName?: string;
}) => {
  const paramStrings = [];
  if (params.fundId) {
    paramStrings.push(`fundId=${params.fundId}`);
  }
  if (params.fundName) {
    paramStrings.push(`fundName=${params.fundName}`);
  }
  if (paramStrings.length === 0) return '';
  return '?' + paramStrings.join('&');
};
